import { useState } from 'react';
import { CTABanner } from '../../components/ui/UtilsLayout';
import { imagePath } from '../../utils/imagePath';
import {
    CaseStudyCard,
  ImageWithFeatureList,
  IndustriesImagesCard,
  RetailECommerceFeatureCard,
} from '../../utils/IndustriesData/IndustriesData';
import { CalendlyScheduler } from '../../components/ScheduleDemoComponents/ScheduleDemoComponents';

import { TourismHospitalityFeaturesData } from '../../components/data/data/Industries/IndustriesStaticData';

export const TourismHospitality = () => {
   const [showScheduler, setShowScheduler] = useState(false);

   const openScheduler = () => setShowScheduler(true);
   const closeScheduler = () => setShowScheduler(false);
  return (
    <div className="relative pt-14 sm:pt-20 md:pt-0">
      <div className="hidden lg:block absolute -top-[460px] right-[10px] md:right-[20px] lg:right-[0px]">
        <img
          className="w-[200px] md:w-[250px] lg:w-[430px] h-auto object-contain "
          src={imagePath?.reaearch1}
          alt="Grid AI"
        />
      </div>
      {/* Hero / Image Section */}
      <section className=" relative z-10 mt-4 sm:mt-6 md:mt-24 lg:mt-10 flex items-start lg:items-center px-3 sm:px-4 md:px-6 lg:px-8 py-8 lg:py-28">
        <div className="max-w-7xl w-full mx-auto">
          <IndustriesImagesCard
            title="Tourism & "
            subtitle="Hospitality"
            description="Creating memorable, interactive experiences that bring places and stories to life."
            image={imagePath?.TourismHospitality}
            mobileImage={imagePath?.TourismHospitalityMobile}
            buttonText="Schedule a Demo"
            loading="eager"
            fetchpriority="high"
            onButtonClick={openScheduler}
          />
        </div>
      </section>
      <div className="hidden lg:block absolute sm:top-[320px] md:top-[320px] lg:top-[655px] left-0 z-[0]">
        <img
          className="w-[100px] sm:w-[180px] md:w-[460px] lg:w-[530px] h-auto object-contain"
          src={imagePath?.Research4}
          alt="Grid AI"
        />
      </div>

      <section className=" relative z-10 w-full bg-[#1E1E22] py-8 sm:py-12 ">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-10">
          <div className="mb-6 sm:mb-8 md:mb-10 lg:mb-12 max-w-full sm:max-w-6xl">
            <h2 className="text-[#FFFFFF] text-md sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-extrabold mb-2 sm:mb-3 md:mb-4 leading-tight">
              Our Case Studies
            </h2>
            <p className="text-[#FFFFFF] text-md sm:text-sm md:text-base lg:text-lg leading-relaxed">
              Driving meaningful visitor engagement with immersive content that
              elevates how guests explore, learn, and experience new places.
            </p>
          </div>
          <div className="max-w-5xl">
            <CaseStudyCard
              title="Karnataka Tourism"
              description="An immersive AR and MR experience for Karnataka Tourism, showcasing Vittala Temple a heritage site destination showcasing cultural narratives through interactive storytelling and virtual exploration to enhance visitor engagement and destination discovery."
              image={imagePath.KarnatakaTourism}
              to="/all-industries/karnataka-tourism"
            />
          </div>
        </div>
      </section>

      {/* Image With Feature List (SEPARATE SECTION) */}
      <section className="w-full py-10 sm:py-14 md:py-16 lg:py-20 px-0 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto ">
          <ImageWithFeatureList
            image={imagePath?.DiscoverImmerce}
            imageTitle={['Discover, Immerce,', 'and Remember.']}
            mobileFullImage={imagePath?.DiscoverImmerseMobile}
            features={TourismHospitalityFeaturesData}
          />
        </div>
      </section>
      <div className="hidden md:block absolute bottom-[-80px] md:-left-40 lg:left-0 ">
        <img
          className="w-[180px] md:w-[260px] lg:w-[460px] h-auto object-contain rotate-180"
          src={imagePath?.research3}
          alt="Grid AI"
        />
      </div>

      <section className="w-full mx-auto px-0 sm:px-6 lg:px-8 py-12 max-w-[1350px]">
        <div className="relative sm:left-0 md:left-4">
          <CTABanner
            welcomeText="Bring Every Destination to Life"
            description="Create unforgettable travel, cultural, and hospitality experiences with spatial storytelling, guided AR tours, and immersive on-site interactions."
            buttonText="Contact Us"
            navigateTo="/contact-us"
          />
        </div>
      </section>
      {showScheduler && <CalendlyScheduler onClose={closeScheduler} />}
    </div>
  );
};
